import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { LanguageService } from './core/services/LanguageService';
import { otsGuestAuthInterceptor } from './features/order-to-seat/core/interceptors/otsGuestAuthInterceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([otsGuestAuthInterceptor])),
    provideRouter(routes),
    provideAppInitializer(() => {
      const languageService = inject(LanguageService);
      return languageService.loadLanguage();
    })
  ]
};
